import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import "app/static/frontend/components/stylus/BillStatusTimeline.styl"

export const RegulationStatusTimeline = (props) => {
    const achievedStatuses = props.achievedStatuses || (props.data.length && props.data[0].achievedStatuses)
    const timelineEnum = props.timelineEnum || (props.data.length && props.data[0].timelineEnum)
    const getSteps = () =>
        achievedStatuses.map((status) => {
            const curEnumElement = timelineEnum.by_value(status.get("status"))
            const label = curEnumElement.short_label || curEnumElement.label
            const achieved = status.get("achieved")

            return (
                <i
                    className={classNames(
                        "timeline-item",
                        { "timeline-item-completed": achieved }
                    )}
                    data-title={label}
                    key={curEnumElement.value}
                >
                    <div
                        className={classNames(
                            "timeline-item-pdf-text",
                            { completed: achieved }
                        )}
                    >
                        {label}
                    </div>
                </i>
            )
        })

    let widthVal = 0
    achievedStatuses.forEach((el, i) => {
        if (el.get("achieved")) {
            widthVal = i
        }
    })
    return (
        <div className={classNames(
            "bill-status-timeline",
            { "has-title": !!props.title }
        )}>
            { props.title && <div className="section-title">{props.title}</div> }
            <div className={
                classNames(
                    "bill-status-timeline-inner",
                    { "bill-profile": !!props.title }
                )}>
                <div
                    className={`completed-inner completed-inner-${widthVal}`}
                    style={{ width: `${((widthVal) / (achievedStatuses.size - 1)) * 100}%` }}
                />
                { getSteps() }
            </div>
        </div>
    )
}

RegulationStatusTimeline.propTypes = {
    achievedStatuses: PropTypes.object,
    timelineEnum: PropTypes.object,
    data: PropTypes.array,
    title: PropTypes.string,
}

export default RegulationStatusTimeline
